import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ParametersDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { SolicitudCambiarEstadoI } from 'src/app/infraestructure/models/solicitudCambiarEstado.interface';
import { ValidacionSolicitudReferenteI } from 'src/app/infraestructure/models/validacionSolicitudReferente.interface';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';
import { ReferentApiService } from 'src/app/infraestructure/services/referent/referent-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-validacion-datos-solicitud-servicio',
  templateUrl: './validacion-datos-solicitud-servicio.component.html',
  styleUrls: ['./validacion-datos-solicitud-servicio.component.scss']
})
export class ValidacionDatosSolicitudServicioComponent implements OnInit {

  @Output() cancel = new EventEmitter<string>();
  @Output() reloadTable = new EventEmitter<boolean>();

  @Input() codeSolicitud: number = 0;


  $parametricList: ParametersDTO = new ParametersDTO();
  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;

  dataValidar = {} as ValidacionSolicitudReferenteI;
  dataTxtValidationDatosJson: number[] = [];
  dataSolicitud = {} as SolicitudCambiarEstadoI;
  observacionForm = {} as FormGroup;

  rolId: number = 0;
  userId: number = 0;


  constructor(private _listSrv: ParametricListsService,
    private referentApiSrv: ReferentApiService,
    private fb: FormBuilder,
    private store: Store<AppState>,) {
    this.user$ = this.store.select(state => state.user);
    this.user$.subscribe(user => {
      this.rolId = user.rolId;
      this.userId = user.id;
    });
  }

  ngOnInit(): void {

    this.observacionForm = this.fb.group({
      TxtObservacion: ['', Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚ,.\s]*$/)],
    });

    this._listSrv.getDataLists('TIP_VALIDACIONES')
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code == 200) this.$parametricList.typeValidationsList = res.data;
      });
  }

  onSelectCheck(event: any) {

    const item: number = Number((event.target as HTMLInputElement).value);
    const check: any = (event.target as HTMLInputElement).checked;

    if (check === true) this.dataTxtValidationDatosJson.push(item);

    if (check === false) {
      const indiceAEliminar = this.dataTxtValidationDatosJson.indexOf(item);
      if (indiceAEliminar !== -1) this.dataTxtValidationDatosJson.splice(indiceAEliminar, 1);
    }
  }

  onEnviar() {
    this.dataValidar.TxtValidacionDatosJson = this.dataTxtValidationDatosJson.toString();
    this.dataValidar.TxtObservacion = this.observacionForm.get('TxtObservacion')?.value;

    this.dataSolicitud.accion = 'ENVIAR_VALIDACION_DATOS';
    this.dataSolicitud.rolId = this.rolId;
    this.dataSolicitud.usuarioId = this.userId;
    this.dataSolicitud.solicitudId = this.codeSolicitud;
    this.dataSolicitud.datos = this.dataValidar;

    this.referentApiSrv.putSolicitudCambiarestado(this.dataSolicitud)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: `Solicitud exitosa`,
            text: `Validación de datos enviada exitosamente para la solicitud de servicio #${res.data.solicitudId}`,
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
          this.reloadTable.emit(true);
          return this.onCancel();
        } else {
          const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
          Swal.fire({
            title: 'Errores',
            icon: 'error',
            html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
        }
      });

    // Swal.fire({
    //   position: "center",
    //   icon: "warning",
    //   title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
    //   text: `La petición se direccionara al módulo de validación de datos del servicio`,
    //   showConfirmButton: true,
    //   confirmButtonColor: "#2BA3BF",
    //   confirmButtonText: "ACEPTAR",
    // }).then((result) => {
    //   if (result.isConfirmed) {
        
    //   }
    // });
  }

  onCancel() {
    this.cancel.emit('close');
  }

  onTextareaInput(event: any) {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚ,.\s]/g, '');
    this.observacionForm.get('TxtObservacion')?.setValue(sanitizedValue, { emitEvent: false });
  }
}